import { MailOrderPricesPageProps } from "../types";
import { MailOrderPricesSearchForm } from "../Components/Forms";
import { QuantityDisclaimer, QuotesTable } from "../Components/MailOrderPrices";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const MailOrderPricesPage = ({
    pageState,
    mailOrderPricesResults,
}: MailOrderPricesPageProps) => {
    return (
        <div className="overflow-hidden w-full mx-auto flex flex-col">
            <div className="flex flex-col">
                <MailOrderPricesSearchForm pageState={pageState} />
                {mailOrderPricesResults &&
                    mailOrderPricesResults?.length > 0 && (
                        <QuotesTable quotes={mailOrderPricesResults} />
                    )}
            </div>
        </div>
    );
};

export default MailOrderPricesPage;
